// KpiGrid → FormulaPopover / KpiCellEditor kırılım bölümü bağlantısı (spec §6.2, DR4) — KpiGrid.tsx
// 600 satır sınırı için ayrı. Bilgi saf `breakdownEditorInfo`'dan; eylemler çağırandan (sayfa):
// [Seti düzenle], [Kırılımı bu sete ekle] (Task 14 modalı), bekleme seçicisi (kpi-store
// `pendingCells`). Portalda set eylemleri verilmez.

import type { KpiResolvedGrid } from "@mahir/shared";
import { breakdownEditorInfo } from "../../lib/kpi-breakdown-editor";
import { readonlyHintFor, type GridColumn, type GridRow } from "../../lib/kpi-grid-nav";
import type { KpiCellBreakdownProps } from "./KpiCellBreakdownSection";

/** Sayfanın KpiGrid'e verdiği kırılım eylemleri (danışman). */
export interface GridBreakdownHandlers {
  /** DR4 bekleme — toplam hücresi (gösterge × kolon) üye kaydı sürerken meşgul mü */
  isRecomputing?: ((indicatorId: string, col: GridColumn) => boolean) | undefined;
  /** (1) üye sette eksik → [Seti düzenle] */
  onEditSet?: (() => void) | undefined;
  /** (3) hesap grubu başka sette → [Kırılımı bu sete ekle] (toplamın satır kimliği) */
  onAddBreakdownToSet?: ((indicatorId: string) => void) | undefined;
}

export function breakdownPropsFor(
  grid: KpiResolvedGrid,
  row: GridRow,
  col: GridColumn,
  client: boolean,
  h: GridBreakdownHandlers & {
    onJumpTo: (indicatorId: string) => void;
    onAddReported?: (() => void) | undefined;
  },
): KpiCellBreakdownProps | undefined {
  const info = breakdownEditorInfo(row.indicator, grid.indicators, col, client);
  if (!info) return undefined;
  const add = h.onAddBreakdownToSet;
  return {
    info,
    recomputing: h.isRecomputing?.(row.indicator.id, col) ?? false,
    onJumpTo: h.onJumpTo,
    ...(client
      ? {}
      : {
          onEditSet: h.onEditSet,
          onAddBreakdownToSet: add ? () => add(row.indicator.id) : undefined,
          onAddReported: h.onAddReported,
        }),
  };
}

/** Toplam / grup hücresine yazma denemesi → kullanıcı ipucu (sessiz yok sayma yerine). */
export function breakdownHintFor(
  grid: KpiResolvedGrid,
  row: GridRow | undefined,
  client: boolean,
): string | null {
  return row ? readonlyHintFor(row.indicator, grid.indicators, client) : null;
}
